import React from 'react';
import Loading from '../Loader/Loader';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import ErrorPage from '../Error/ErrorPage';
import '../../assets/style/SignDocument.css';

const SigningResponse = (props) => {
  const { error, fetching, t } = props;

  return (
    <div className="response-container">
      {!error && fetching && <Loading />}

      {error ? (
        <ErrorPage />
      ) : (
        <div className="response-wrapper">
          <div className="success-card">
            <div className="success-icon-wrapper">
              <div className="success-icon">
                <svg
                  width="80"
                  height="80"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="8 12 11 15 16 9" />
                </svg>
              </div>
              <div className="success-ring"></div>
            </div>

            <h1 className="success-title">{t('esign.thankyouMsg')}</h1>
            <p className="success-message">{t('esign.documentSignerMsg')}</p>

            <div className="success-details">
              <div className="detail-item">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <span>{t('emailsigning.documentsignedsuccessmsg')}</span>
              </div>

              <div className="detail-item">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
                <span>{t('emailsigning.securelystoredmsg')}</span>
              </div>

              <div className="detail-item">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <span>{t('emailsigning.entercodemsg')}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  error: state.error.isError,
});

export default connect(mapStateToProps)(
  withTranslation('common')(SigningResponse)
);